
import { useNavigate } from "react-router-dom";
import { TableBody, TableCell, TableHead, TableRow, Stack, Pagination } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";


const paginado = Number(process.env.REACT_APP_PAGINADO);





export const TablaListadoCategoria = ({ data, chagePage=() => {}, page=0 }) => {


    const navigate = useNavigate();


    
    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(50 / +paginado)} disabled={Math.ceil(50 / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead >
                    <TableRow>
                        <TableCell sx={{width:'25%'}}>Nombre</TableCell>
                        <TableCell sx={{width:'15%'}}>Unidad</TableCell>
                        <TableCell sx={{width:'10%'}}>2-6</TableCell>
                        <TableCell sx={{width:'10%'}}>7-12</TableCell>
                        <TableCell sx={{width:'10%'}}>13-24</TableCell>
                        <TableCell sx={{width:'10%'}}>25-50</TableCell>
                        <TableCell sx={{width:'10%'}}>51-99</TableCell>
                        <TableCell sx={{width:'10%'}}>Opciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (c) => (
                    <TableRow key={ c.id }>
                        <TableCell>{ c.nombre }</TableCell>
                        <TableCell>{ c.primero }</TableCell>
                        <TableCell>{ c.segundo }</TableCell>
                        <TableCell>{ c.tercero }</TableCell>
                        <TableCell>{ c.cuarto }</TableCell>
                        <TableCell>{ c.quinto }</TableCell>
                        <TableCell>{ c.sexto }</TableCell>
                        <TableCell>
                            <TooltipAndIcon
                                titulo="Editar Categoria"
                                icono="editar"
                                color="white"
                                onClick={ () => navigate(`/super/actualizar-categ/${c.id}`) }
                            />  
                        </TableCell>
                    
                    </TableRow>
                    ))
                    }
                </TableBody>
            </LayoutTabla>

        :    <MensajeAlertaDanger titulo='No hay Usuarios Disponibles' />
        }
        </>
    )
}
